export interface CodeBlock {
  language: string     // e.g. 'css', 'tsx', 'bash'
  label?: string       // optional filename label
  code: string
}

export interface PostSection {
  heading: string
  body: string[]       // each string is a paragraph
  note?: string        // optional callout/highlight
  code?: CodeBlock     // optional code snippet after body
}

export interface Post {
  slug: string
  title: string
  subtitle: string
  date: string
  readTime: string
  intro: string
  sections: PostSection[]
  closing: string
}

export const posts: Post[] = []
